import script from "./userTableCellWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./userTableCellWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./userTableCellWrapper.vue?vue&type=style&index=0&id=641ad3b1&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641ad3b1"]])

export default __exports__